import React from 'react'

import { useEditSegmentList } from '../hooks'

import IncidentDate from '../../incidents/components/IncidentDate'

import styles from './SegmentList.module.css'

const EditSegmentList = () => {
  const [segments, { onHover, onHoverEnd, remove, add }] = useEditSegmentList()

  return (
    <ul className={styles.list}>
      {segments.length === 0 && <div>No Roads Added.</div>}
      {segments.map((segment, i) => (
        <li
          key={i}
          className={`${styles.listItem} ${
            segment.removed ? styles.removed : segment.new ? styles.new : ''
          }`}
          onMouseEnter={onHover(segment.id)}
          onMouseLeave={onHoverEnd(segment.id)}
          onClick={segment.removed ? add(segment) : remove(segment)}
        >
          <div className={styles.meta}>Closed</div>
          <div className={styles.name}>
            {segment.name}, {segment.city}
          </div>
          <IncidentDate style={styles.meta} date={segment.closedSince} />
          <div className={styles.block}>{segment.block}</div>
        </li>
      ))}
    </ul>
  )
}

export default EditSegmentList
